import React, { useState } from "react";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import { Button, Card, CardBody, CardTitle } from "reactstrap";
import toastr from "toastr";

export const DialogContext = React.createContext();

export const DialogProvider = (props) => {
  const [isDontSave, setIsDontSave] = useState(false);
  const [showLogsP, setShowLogsP] = useState(false);
  const [conf, setConf] = useState(false);

  toastr.options = {
    positionClass: "toast-top-right",
    timeOut: 10000,
    extendedTimeOut: 1000,
    closeButton: true,
    progressBar: true,
    preventDuplicates: false,
    newestOnTop: true,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "slideDown",
    hideMethod: "slideUp",
    showDuration: 300,
    hideDuration: 1000,
  };

  // const showMessage = async (toastType, message, title) => {
  //   if (message?.message) {
  //     try {
  //       message = JSON?.parse(message?.message);
  //       message = message?.message + " " + message?.customMessage;
  //     } catch (e) { }
  //   }
  //   if (toastType === "info") toastr.info(message, title);
  //   else if (toastType === "warning") toastr.warning(message, title);
  //   else if (toastType === "error") toastr.error(message, title);
  //   else toastr.success(message, title);
  // };

  const normalizeDialogText = (value, fallback = "Something went wrong.") => {
    if (typeof value === "string") {
      return value;
    }

    if (value === null || value === undefined) {
      return fallback;
    }

    if (typeof value === "number" || typeof value === "boolean") {
      return String(value);
    }

    if (typeof value === "object") {
      if (typeof value?.customMessage === "string" && value.customMessage.trim()) {
        return value.customMessage;
      }

      if (typeof value?.message === "string" && value.message.trim()) {
        return value.message;
      }

      try {
        return JSON.stringify(value);
      } catch (error) {
        return fallback;
      }
    }

    return fallback;
  };

  const renderDialogContent = (value, fallback = "") => {
    if (React.isValidElement(value)) {
      return value;
    }

    if (Array.isArray(value)) {
      return value;
    }

    return normalizeDialogText(value, fallback);
  };

  const showMessage = async (message, title) => {
    if (message?.message) {
      try {
        message = JSON?.parse(message?.message);
        message = message?.message + " " + message?.customMessage;
      } catch (e) { }
    }
    toastr.success(normalizeDialogText(message), normalizeDialogText(title, ""));
  };

  const showInfo = async (message, title) => {
    if (message?.message) {
      try {
        message = JSON?.parse(message?.message);
        message = message?.message + " " + message?.customMessage;
      } catch (e) { }
    }
    toastr.info(normalizeDialogText(message), normalizeDialogText(title, ""));
  };

  const showWarning = async (message, title) => {
    if (message?.message) {
      try {
        message = JSON?.parse(message?.message);
        message = message?.message + " " + message?.customMessage;
      } catch (e) { }
    }
    toastr.warning(normalizeDialogText(message), normalizeDialogText(title, ""));
  };

  const showError = async (e) => {
    if (typeof e === "string") {
      toastr.error(normalizeDialogText(e), "Error");
      return;
    }
    if (typeof e?.message === "string" && e.message.includes("{")) {
      const parsedMessage = JSON?.parse(e?.message);
      toastr.error(
        normalizeDialogText(
          parsedMessage?.customMessage
            ? parsedMessage?.customMessage
            : parsedMessage?.message,
        ),
        "Error"
      );
    } else {
      const normalizedErrorMessage = normalizeDialogText(e?.message || e);
      toastr.error(normalizeDialogText(normalizedErrorMessage), "Error");
    }
  };

  function promise(props) {
    return new Promise(function (resolve, reject) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <>
              <Card style={{ width: "300px" }}>
                  <CardBody style={{ zIndex: "1" }}>
                  <CardTitle style={{ marginTop: "10px" }}>
                    <div>{renderDialogContent(props?.title, "")}</div>
                  </CardTitle>
                  <div style={{ fontSize: "15px", marginTop: "20px" }}>
                    {renderDialogContent(props?.description, "")}
                  </div>
                  <div className="row d-flex justify-content-end">
                    {props?.isSaveWarn ? (
                      <Button
                        type="button"
                        color="dark"
                        outline
                        className=" col-4 mt-3 waves-effect waves-light"
                        onClick={() => {
                          setIsDontSave(true);
                          resolve();
                          onClose();
                        }}
                      >
                        {normalizeDialogText("Don't Save", "Don't Save")}
                      </Button>
                    ) : null}
                    <div
                      style={{ fontSize: "15px", marginTop: "30px" }}
                      className=" d-flex justify-content-between"
                    >
                      <Button
                        type="button"
                        color="dark"
                        outline
                        className=" col-5  mt-3 waves-effect waves-light"
                        onClick={() => {
                          reject();
                          onClose();
                        }}
                      >
                        {normalizeDialogText(props?.reject ? props?.reject : "Cancel", "Cancel")}
                      </Button>
                      <Button
                        type="button"
                        color="danger"
                        className="col-5 mx-2  mt-3 waves-effect waves-light"
                        onClick={() => {
                          resolve();
                          onClose();
                        }}
                      >
                        {normalizeDialogText(props?.isSaveWarn
                          ? "Save"
                          : props?.proceed
                            ? props?.proceed
                            : "OK", "OK")}
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </>
          );
        },
      });
    });
  }

  const showConfirm = async (props) => {
    let isConfirm = true;
    await promise(props)
      .then(function () {
        isConfirm = isDontSave ? 2 : true;
      })
      .catch(function () {
        isConfirm = false;
      });
    return isConfirm;
  };

  return (
    <DialogContext.Provider
      value={{
        showMessage,
        showInfo,
        showWarning,
        showConfirm,
        showError, setShowLogsP, showLogsP, setConf, conf

      }}
    >
      {props?.children}
    </DialogContext.Provider>
  );
};
